import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useStore } from '../lib/store'

export function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { handleCognitoCallback } = useStore()
  const [error, setError] = useState('')

  useEffect(() => {
    const code = searchParams.get('code')
    const errorParam = searchParams.get('error')

    if (errorParam) {
      setError(decodeURIComponent(errorParam))
      setTimeout(() => navigate('/login'), 3000)
      return
    }

    if (!code) {
      setError('No authorization code received')
      setTimeout(() => navigate('/login'), 3000)
      return
    }

    // Exchange code for token
    handleCognitoCallback(code)
      .then(() => {
        {
          const dest = sessionStorage.getItem('scribey_post_login')
          sessionStorage.removeItem('scribey_post_login')
          navigate(dest || '/')
        }
      })
      .catch((err) => {
        setError(err.message || 'Authentication failed')
        setTimeout(() => navigate('/login'), 3000)
      })
  }, [searchParams, handleCognitoCallback, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-gray-100 dark:bg-gray-900 rounded-xl p-8 shadow-xl border border-gray-200 dark:border-gray-800 text-center">
          {error ? (
            <>
              <div className="text-red-500 dark:text-red-400 text-lg font-semibold mb-2">Authentication Failed</div>
              <p className="text-gray-500 dark:text-gray-400 mb-4">{error}</p>
              <p className="text-sm text-gray-400 dark:text-gray-500">Redirecting to login...</p>
            </>
          ) : (
            <>
              <div className="w-16 h-16 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-gray-700 dark:text-gray-300 text-lg">Completing sign-in...</p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
